// Tiny colored pill for deck-source provenance (MTGO, mtgtop8, Archidekt,
// etc). Tier colors match the scorer's tier_weight ordering — higher tier
// = warmer hue.

import { cn } from "../lib/cn";

const SOURCE_CLASSES: Record<string, { label: string; cls: string }> = {
  mtgo: { label: "MTGO", cls: "bg-orange-500/15 text-orange-300 border-orange-500/40" },
  mtgtop8: { label: "mtgtop8", cls: "bg-amber-500/15 text-amber-300 border-amber-500/40" },
  mtggoldfish: { label: "mtggoldfish", cls: "bg-yellow-500/15 text-yellow-300 border-yellow-500/40" },
  mtgdecks: { label: "mtgdecks", cls: "bg-lime-500/15 text-lime-300 border-lime-500/40" },
  moxfield: { label: "Moxfield", cls: "bg-emerald-500/15 text-emerald-300 border-emerald-500/40" },
  archidekt: { label: "Archidekt", cls: "bg-sky-500/15 text-sky-300 border-sky-500/40" },
};

export default function SourceBadge({ source }: { source: string }) {
  const entry = SOURCE_CLASSES[source.toLowerCase()] ?? {
    label: source,
    cls: "bg-bg-raised text-fg-muted border-border",
  };
  return (
    <span className={cn("badge border text-[10px] uppercase tracking-wider", entry.cls)}>
      {entry.label}
    </span>
  );
}
